// ── CONFIGURACIÓN CENTRAL DE PERMISOS ─────────────────────
// Fuente unica. Si se añade un permiso, se añade AQUI y en ningun otro sitio.
// No hay permisos por rol: el admin concede cada uno individualmente.
// Unica excepcion: el rol "admin" siempre tiene acceso a todo.

export const ARBOL_PERMISOS = [
  { modulo: '🏗 Máquinas', permisos: [
    { key: 'ver_maquinas', label: 'Ver el módulo' },
    { key: 'gestionar_maquinas', label: 'Dar de alta y modificar máquinas' },
    { key: 'cost_control_maquinas', label: '€ Cost control de máquinas (margen por proyecto)' },
  ]},
  { modulo: '🔧 Intervenciones', permisos: [
    { key: 'ver_intervenciones', label: 'Ver el módulo' },
    { key: 'gestionar_intervenciones', label: 'Crear y editar intervenciones' },
    { key: 'aprobar_intervenciones', label: 'Aprobar y devolver informes' },
    { key: 'gestionar_garantias', label: 'Gestión de garantías (reparto de costes)' },
    { key: 'gestionar_tarifario', label: '€ Ver y modificar el tarifario de servicio' },
  ]},
  { modulo: '📦 Almacén', permisos: [
    { key: 'ver_almacen', label: 'Ver el módulo' },
    { key: 'almacen_gestionar_stock', label: 'Gestionar el stock y las entradas' },
    { key: 'almacen_dar_salida', label: 'Dar salidas y preparar pedidos' },
    { key: 'almacen_recibir_solicitudes', label: 'Recibir y aprobar solicitudes de material' },
    { key: 'almacen_solo_solicitar', label: 'Solo solicitar material (técnicos)' },
    { key: 'usar_megascan', label: 'Usar MegaScan (lectura de albaranes)' },
  ]},
  { modulo: '👤 Clientes', permisos: [
    { key: 'ver_clientes', label: 'Ver el módulo' },
    { key: 'gestionar_clientes', label: 'Crear y modificar clientes' },
    { key: 'cost_control_clientes', label: '€ Cost control de clientes (rentabilidad)' },
  ]},
  { modulo: '📈 Comercial', permisos: [
    { key: 'ver_comercial', label: 'Ver el módulo' },
    { key: 'ver_oportunidades', label: 'Ver oportunidades' },
    { key: 'ofertas_comerciales', label: 'Crear y gestionar ofertas comerciales' },
    { key: 'estudios_operacion', label: '€ Estudios de operación' },
  ]},
  { modulo: '📑 Administración', permisos: [
    { key: 'ver_administracion', label: 'Ver el módulo' },
    { key: 'facturacion', label: 'Emitir y gestionar facturas' },
    { key: 'tesoreria', label: 'Tesorería: cobros, pagos y previsión' },
    { key: 'compras', label: 'Pedidos y facturas de proveedor' },
  ]},
  { modulo: '👷 Usuarios', permisos: [
    { key: 'ver_usuarios', label: 'Ver el módulo de usuarios' },
    { key: 'ver_todas_jornadas', label: 'Ver los fichajes de toda la empresa' },
    { key: 'costes_personal', label: '€ Ver y modificar los costes por hora (confidencial)' },
    { key: 'gestionar_documentacion', label: 'Gestionar la documentación del personal' },
  ]},
  { modulo: '🛠 Otros', permisos: [
    { key: 'ver_tareas', label: 'Ver tareas' },
    { key: 'ver_academy', label: 'HEI Academy' },
    { key: 'publicar_avisos', label: 'Publicar avisos en la pantalla de inicio' },
    { key: 'gestionar_incidencias', label: 'Gestionar las incidencias del SIS' },
  ]},
];

export const TODOS_LOS_PERMISOS: string[] =
  ARBOL_PERMISOS.flatMap(g => g.permisos.map(p => p.key));

export type Rol = 'admin' | 'usuario';

/**
 * Los permisos efectivos son EXACTAMENTE los concedidos individualmente.
 * Unico caso especial: el rol "admin" tiene todos.
 */
export function calcularPermisosEfectivos(rol: string, permisosIndividuales: string[]): string[] {
  if (rol === 'admin') return TODOS_LOS_PERMISOS;
  return permisosIndividuales || [];
}

export function tienePermiso(rol: string, permisosIndividuales: string[], permiso: string): boolean {
  if (rol === 'admin') return true;
  return (permisosIndividuales || []).includes(permiso);
}